export const configData =  {  

    APP_URL: "/basic/web/api/",
    // Page shown at "/" (the Drupal front page node)
    HOME_PAGE_PATH: "node/523",
    DOMAIN_URL: "https://alphateam.preferati.net/basic/web/",
    DRUPAL_APP_URL: "https://betasmww.preferati.net/api/",
    // The Drupal copy (the old dev site, not part of go-live): the sign-in hand-over and the
    // screens' loggedin_domain checks. No files are loaded from it (DRUPAL_LIVE_DOMAIN_URL)
    DRUPAL_DOMAIN_URL: "https://betasmww.preferati.net",
    // The live Drupal site: Drupal's files (/sites/...: pictures, banners, placeholders, files
    // linked from page bodies) are loaded from here, which has them all
    DRUPAL_LIVE_DOMAIN_URL: "https://www.sportsmanagementworldwide.com",
    // The live site's picture CDN (cloudimg.io): live's pages load its files through it, resized
    // and compressed (it serves only the live site's files, not the copy's). The backend's
    // IMAGE_CDN_URL (config/params.php) is the same
    IMAGE_CDN_URL: "https://aisiiczsuo.cloudimg.io/v7/",
    // The live site's picture for shared links (og:image) on pages without one of their own;
    // also in public/index.html, for link previews that do not run the app
    DEFAULT_OG_IMAGE: "https://www.sportsmanagementworldwide.com/images/smwwglobe_new.png",
    AGENCY_DOMAIN_URL: "https://alphasmwwagency.preferati.net",
    SCOUT_DOMAIN_URL: "https://alphasmwwscout.preferati.net",
    RSMWW_DOMAIN: "alphasmww.preferati.net",
    RSMWW_AGENCY_DOMAIN: "alphasmwwagency.preferati.net",
	RSMWW_AGENCY_DOMAIN1: "alphasmwwagency.preferati.net",
    RSMWW_SCOUT_DOMAIN: "alphasmwwscout.preferati.net",
	RSMWW_SCOUT_DOMAIN1: "alphasmwwscout.preferati.net",
	RSMWW_SCOUT_DOMAIN2: "alphasmwwscout.preferati.net",
    // Where links to the Agency/Scout sites go. Alpha has no agency/scout hosts of its own
    // (the presmww* ones run the older build on the preteamsmww backend), so they stay on
    // alpha, whose routes serve those pages too. Live: https://www.smwwagency.com / https://www.smwwscout.com
    RSMWW_AGENCY_URL: "https://alphasmwwagency.preferati.net",
    RSMWW_SCOUT_URL: "https://alphasmwwscout.preferati.net",
    RSMWW_URL: "https://alphasmww.preferati.net",
    // The "team" site: the live deployment of this app, where the public site's Login link and
    // cart icon go. Alpha serves those pages itself. Live: https://team.sportsmanagementworldwide.com
    RSMWW_TEAM_URL: "https://alphateam.preferati.net",
    GOOGLE_RECAPTCHA_SITE_KEY: '6LeGtQoTAAAAAC7f3LyY82WLCfOH66NMbs9f6eNv',
    //GOOGLE_RECAPTCHA_SITE_KEY: '6LeUZTYsAAAAAOl-sjYYG5jRdVv8MsvQ0rOajT_Q',
    DOMAIN_PUBLIC_URL: `${window.location.protocol}//${window.location.hostname}`,
    FB_PIXEDL_ID: '123456789',
    ROLE_ADMINISTRATOR: 3,
    ROLE_SAADMIN: 8,
    ROLE_SALES_PEOPLE:10,
    ROLE_SALES_DIRECTOR:18,
    ROLE_APPLICATION:12,
    ROLE_GLOBAL_AMBASSADOR:26,
    ROLE_AGENT:6,
    ROLE_SCOUT:5,
    ROLE_ATHLETE:11,
    ROLE_MENTOR:7,
    ROLE_AUTHENTICATED_USER:2
     }